import PubNub from "pubnub";
import store from "../../store";
import { PubnubKeys } from "../session/types";
import { RootDispatch, RootGetState, RootContext } from "../types";
import { createPubNubListener } from "pubnub-redux";
import { getUnreadCount } from "../SiteHeader/actions";

export const configurePubnub = (pubnubKeys: PubnubKeys, uuid: string) => async (
  dispatch: RootDispatch,
  getState: RootGetState,
  context: RootContext
) => {
  const pubnub = new PubNub({
    publishKey: pubnubKeys.publishKey,
    subscribeKey: pubnubKeys.subscribeKey,
    ssl: true,
    restore: true,
    heartbeatInterval: 0
  });
  context.pubnub.api = pubnub;
  pubnub.addListener(createPubNubListener(store.dispatch));
  context.pubnub.api.setUUID(uuid);
};

export const subscribeChannels = (channels: string[]) => async (
  dispatch: RootDispatch,
  getState: RootGetState,
  context: RootContext
) => {
  context.pubnub.api?.subscribe({
    channels: channels
  });
};

export const unsubscribeChannel = (channel: string) => async (
  dispatch: RootDispatch,
  getState: RootGetState,
  context: RootContext
) => {
  context.pubnub.api?.unsubscribe({ channels: [channel] });
};

export const unsubscribeAllChannels = (disconnect = false) => async (
  dispatch: RootDispatch,
  getState: RootGetState,
  context: RootContext
) => {
  context.pubnub.api?.unsubscribeAll();
  if (disconnect) {
    context.pubnub.api?.stop();
    dispatch(getUnreadCount());
  }
};
